import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import values from "lodash/values";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getRolesDataMap = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].list`), (data) => data);
export const getRolesData = createSelector((state) => getRolesDataMap(state), (data) => (data ? orderBy(values(data), ["Id"], ["desc"]) : undefined));
export const getExpandedPermissions = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].expandedPermissions`, []), (expandedPermissions) => expandedPermissions);
export const getInProgress = (state) => isPending(state, actionTypes.GET_ROLES);
